import { Button } from '~components/generic/editor/Button/Button';
import { ButtonGroup } from '~components/generic/editor/ButtonGroup/ButtonGroup';
import { ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, EditIcon, PenIcon } from '~components/icons';
import styles from './EditComponents.module.css';

export const ButtonGroupSection = () => {
  return (
    <div className={styles.container}>
      <section>
        <h5>ButtonGroup</h5>
        <div className={styles.component}>
          <ButtonGroup>
            <Button icon={<PenIcon />} />
            <Button icon={<ArrowUpIcon />} disabled />
            <Button icon={<ArrowDownIcon />} processing />
          </ButtonGroup>
        </div>
        <div className={styles.component}>
          <ButtonGroup label="Group">
            <Button icon={<EditIcon />} title="Edit" />
            <Button icon={<ArrowUpIcon />} disabled label="Up" />
            <Button preIcon={<ArrowDownIcon />} label="Down" processing />
          </ButtonGroup>
        </div>
        <div className={styles.component}>
          <ButtonGroup label="Group" preIcon="image">
            <Button icon={<PenIcon />} />
            <Button icon={<ArrowUpIcon />} />
            <Button icon={<ArrowDownIcon />} />
          </ButtonGroup>
        </div>
        <div className={styles.component}>
          <ButtonGroup vertical>
            <Button icon={<PenIcon />} />
            <Button icon={<ArrowUpIcon />} />
            <Button icon={<ArrowDownIcon />} />
          </ButtonGroup>
        </div>
        <div className={styles.component}>
          <ButtonGroup preIcon="image" small label="Foobar">
            <Button icon={<EditIcon />} label="Ayy" />
            <Button icon={<EditIcon />} />
            <Button icon={<EditIcon />} label="Ha Yo" />
          </ButtonGroup>
        </div>
        <div className={styles.component}>
          <ButtonGroup>
            <Button icon={<ArrowLeftIcon />} />
            <Button icon={<ArrowRightIcon />} />
          </ButtonGroup>
        </div>
        <div className={styles.component}>
          <ButtonGroup small>
            <Button icon={<ArrowLeftIcon />} />
            <Button icon={<ArrowRightIcon />} />
          </ButtonGroup>
        </div>
      </section>
    </div>
  );
};
